<template>
  <div>
    <banner />
    <div class="absolutecont">
      <div class="web">
        <div class="commonbg">
          <tab cur="/overview" />
          <div class="mainbody">
            <div class="Conpartanyxq">

              <div class="ProductDetailstop clearfix">
                <div class="ProductDetailstopleft">
                  <div class="ProductDetailstopleftimg">
                    <img :src="baseApi+'upload/about/us.png'" alt="合肥信悦信息科技有限公司">
                  </div>
                </div>
                <div class="ProductDetailstopright">
                  <dl>
                    <dt>合肥信悦信息科技有限公司<span>HEFEI XINYUE TECHNOLOGY CO., LTD.</span></dt>
                    <dd>
<!--                      <p>合肥信悦信息科技有限公司（简称：信悦科技）成立于2021年1月，公司位于国家级高新技术开发区合肥高新技术开发区的品恩科技园内，园区环境优美、配套完善、交通便利。公司现拥有智能化二级、机电安装二级资质，同时拥有劳务施工资质及安全生产许可证。</p>-->
                      <p>信悦科技成立于2021年1月，主要从事智能化集成实施、智慧交通平台研发、自动化系统以及驱动产品服务等。公司拥有智能化二级、机电安装二级资质、劳务施工资质、安全生产许可证及18项软著，公司团队在高速公路机电领域深耕多年，业务辐射湖北、广西、福建等多个省市。
                      </p>
                      <br/>
                      <p>信悦科技坚持小核心大外围模式，坚持走创新发展之路，为员工及合作伙伴提供平台，共谋发展。</p>
<!--                      <p> 作为一家高新技术企业，公司始终坚持走创新发展之路，短时间内迅速成为合肥市高新区高新技术企业，同时正在申请国家级高新技术企业。</p>-->
                    </dd>
                  </dl>
                </div>
              </div>
              <img style="width: 100%; margin: 30px 0px" :src="baseApi+'upload/about/c2.png'" >
              <img style="width: 100%; margin: 30px 0px" :src="baseApi+'upload/about/c1.png'" >
              <img style="width: 100%; margin: 30px 0px" :src="baseApi+'upload/about/c3.png'" >
              <div style="height: 200px"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from '@/views/us/componets/Banner'
import Tab from '@/views/us/componets/Tab'
export default {
  components: { Banner, Tab },
  data () {
    return {
      baseApi: process.env.API_ROOT + 'static/'
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/views/us/overview.vue